import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import './OnScrollView.scss';

class OnScrollView extends React.Component {
  constructor(props) {
    super(props);

    this.ref = React.createRef();
  }

  state = {
    scrollItems: null,
  }

  componentDidMount() {
    const { scrollEvents } = this.props;
    if (scrollEvents && scrollEvents.length) {
      this.setUpScrollEvents(scrollEvents);
    }
  }

  checkPosition = (item) => {
    if (!item) { return; }
    item.func(
      item.elems,
      this.ref.current.scrollTop
    );
  }

  onScroll = () => {
    const { scrollItems } = this.state;
    scrollItems.forEach(this.checkPosition);
  }

  setUpScrollEvents = (scrollEvents = []) => {
    const scrollItems = scrollEvents.map((item) => {
      const elems = item.selector
        .map((s) => document.querySelector(s))
        .filter((e) => e !== null);

      if (elems.length) {
        return {
          elems,
          func: item.func,
          position: -1, // -1 above the top, 0 in view, 1 below the bottom
        };
      }
      return null;
    });

    this.setState({
      scrollItems,
    });
  }

  render() {
    const { children, className } = this.props;
    const { scrollItems } = this.state;
    const scroll = (scrollItems) ? { onScroll: this.onScroll } : null;

    return (
      <div className={cx('OnScrollView', className)} {...scroll} ref={this.ref}>
        {children}
      </div>
    );
  }
}

OnScrollView.propTypes = {
  children: PropTypes.element.isRequired,
  className: PropTypes.string,
  scrollEvents: PropTypes.arrayOf(
    PropTypes.shape({
      selector: PropTypes.arrayOf(
        PropTypes.string
      ),
      func: PropTypes.func,
    })
  ),
};

OnScrollView.defaultProps = {
  className: '',
  scrollEvents: null,
};

export default OnScrollView;
